// umleitung alter Browser
import Bowser from "bowser"; 
const browser = Bowser.getParser(window.navigator.userAgent)
if(browser.satisfies({ie: "<=10",chrome:"<=20"})){
    document.location.href="/oldbrowser.html";
}

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

/*
//bootstrap vue einfach alles
*/
import BootstrapVue from "bootstrap-vue"
Vue.use(BootstrapVue)

import VueI18n from 'vue-i18n'
Vue.use(VueI18n)

export const i18n = new VueI18n({
  locale: navigator.language.split('-')[0] || 'de',   // ISO639-1 en,de,ru,fr,cz, etc.
  fallbackLocale: 'fr',
})


//Navigation swipeClose :: https://www.npmjs.com/package/vue2-touch-events
import Vue2TouchEvents from 'vue2-touch-events'
Vue.use(Vue2TouchEvents)

export const bus = new Vue() /* Im the event bus : import{bus} from '../app' bus.$emit ; bus.$on */

import App from './App.vue'
import router from './router/index.js'

import store from './store/index.js'

import Axios from 'axios' //https://github.com/axios/axios
export const axios = Axios.create() // import axios from '.main'
axios.defaults.headers.common['Authorization'] = '--- void ---' // store.user.jwt;
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
axios.defaults.headers.common['Accept-Language'] = i18n.locale
axios.defaults.timeout = 5000; //instance.get('/longRequest', { timeout: 5000});
var axiosCounter = 0

axios.interceptors.request.use(function (config) {
    axiosCounter ++

    setTimeout(function () {
        if (axiosCounter > 0)
            document.getElementById('loading').style.display = 'block'
            //document.body.classList.add('loading-indicator')
        }, 2000)

    return config
}, function (error) {
    return Promise.reject(error)
});

axios.interceptors.response.use((response) => {
    if (axiosCounter > 0) axiosCounter --
    if (axiosCounter === 0)
        document.getElementById('loading').style.display = 'none'
        //document.body.classList.remove('loading-indicator')

    return response
}, function (error) {
    if (axiosCounter > 0) axiosCounter --
    if (axiosCounter === 0)
        document.getElementById('loading').style.display = 'none'
    // Do something with response error
    if (error.response && error.response.status === 403) {
        router.push('/'+i18n.locale+'/login')
        bus.$emit('error',i18n.t('Login'))
        //error.Message = i18n.t('Login');
        //error.jqXHR.
    }

    if(error.message.includes('timeout of')){
    //else{ // sammelpage für fehler sehr blöde idee sämtliche SAP Fehler würden abgefangen werden!!!
        router.push("/" + i18n.locale + "/timeout")
    }

    let customError=''
    try{
        customError = error.response.headers.clientmessage
    } catch(foo){
        customError = null
    }

    if(typeof customError != "undefined"){
        // spezifische Nachrichten an den Client dürfen nicht abgefangen werden.
        // beachte cfheader(name="clientmessage", value="wert für den Client");
        // der Error muss rejected werden und soll in den Catch block laufen
    }
    else{
        //unspezifischer Fehler timeout page anzeigen
        router.push("/" + i18n.locale + "/timeout")
    }
    return Promise.reject(error)
});

export var apiURL = '/components/pis/'
Vue.config.productionTip = false

// custom Component <navigation></navigation>
import Navigation from './components/Navigation.vue'
Vue.component('navigation', Navigation)

import Sidebar from './components/Sidebar.vue'
Vue.component('sidebar', Sidebar)

import Language from './components/Language.vue'
Vue.component('language', Language)

import Search from './components/Search.vue'
Vue.component('search', Search)

import Message from './components/Message.vue'
Vue.component('message', Message)

import cookieconsent from 'vue-cookieconsent-component'
Vue.component('cookie-consent', cookieconsent)

export const loadedLanguages = []
function setLoadedLanguage(lng,status){ loadedLanguages[lng] = status}

export const baseRoutes = ['login','logout','init','timeout']

router.beforeEach(async (to, from, next) => {
    //validate lang
    if (! ['de','fr','it'].includes(to.params.lang)) {
        to.params.lang = 'de'
        next({ path: '/' })
        
    }   
    i18n.locale = to.params.lang
    axios.defaults.headers.common['Accept-Language'] = to.params.lang
    
    /* favicon und manifest.json */
    var link = document.createElement('link');
    link.type = 'image/x-icon';
    link.rel = 'shortcut icon';
    link.href = './favicons/favicon'+to.params.lang+'.ico';
    document.getElementsByTagName('head')[0].appendChild(link);


    var link2 = document.createElement('link');
    link2.sizes = '96x96';
    link2.rel = 'icon';
    link2.href = './favicons/android-chrome-96x96'+to.params.lang+'.png';
    document.getElementsByTagName('head')[0].appendChild(link2);

    var mani = document.createElement('link');
    mani.rel = 'manifest';
    mani.href = './favicons/manifest'+to.params.lang+'.json';
    document.getElementsByTagName('head')[0].appendChild(mani);


    // berechtigung
    if (! baseRoutes.includes(to.path.split('/')[2])) {
        
        // load lang verbesses Timing baseroutes benötigen keine übersetzungen können dafür bereits error anzeigen.
        if (! loadedLanguages[to.params.lang]){
            axios.defaults.headers.common['Accept-Language'] = to.params.lang
            let jqXHR = await axios.get(apiURL + "public.cfc?method=getMessages", {params: { language: to.params.lang }}) // A
            i18n.setLocaleMessage(to.params.lang, jqXHR.data);
            setLoadedLanguage(to.params.lang,true)
        }

        if (store.state.navigationStore.navigation.length === 0) {
            //await store.dispatch('loadNavigation')
        }
        if (! store.state.navigationStore.routes.includes(to.path.split('/')[2])) {
            next({ path: '/login'})
        }
    }

    // busy spinner
    if (axiosCounter > 0) {
        axiosCounter = 0
        document.getElementById('loading').style.display = 'none'
    }

    next()
})
router.afterEach((to) => {
    document.title ='PIS ' + i18n.t(to.name)
    bus.$emit('SidebarClose')
  })

let gaLoader = new Promise(function(resolve) {
    bus.$on('setGoogleanalyticsID',resolve) // resolve(x) ist .then(x)
  })

import VueAnalytics from 'vue-analytics'
Vue.use(VueAnalytics, {
    id: () => gaLoader.then(response => {
        return response
        }),
    router,
    autoTracking:{exception:true}
  })



/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    axios,
    i18n,
    template: '<App/>',
    components: { App },
    created: async function () {
        if (sessionStorage.getItem("jwt") != null) {
            await store.dispatch('setJWT',sessionStorage.getItem("jwt"))
            //bus.$emit('message','restored user session .. ')
            await store.dispatch('loadProfile')
        }
    },
    mounted: function(){
        // dies ist ein reiner IE11 hack weil sonst die Route nicht ausgeführt wird ..??
        var app = this;
        if ("-ms-scroll-limit" in document.documentElement.style && "-ms-ime-align" in document.documentElement.style) {
            window.addEventListener("hashchange",
                function () {
                    var currentPath = window.location.hash.slice(1);
                    if (app.$route.path !== currentPath) {
                        app.$router.replace(currentPath);
                    }
                },
                false);
        }
    }
}) //.$store.dispatch('setJWT',localStorage.getItem("jwt"))